import moment from "moment";
import {WizClassifySelect} from "../../index";

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}
const columns = () => {
  return [
    {
      title: "模版名称",
      name: "title",
      dataIndex: "title",
      tableItem: {width:300 },
      searchItem: {
      },
    },
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "考试分类",
      name: "categoryTypeIds",
      dataIndex: "categoryTypeIds",
      searchItem: {
        type: 'diy',
        diy: WizClassifySelect,
        returnKey: true,
        wizTreeSelectListProps: {
          itemProps: {
            icon: 'unordered-list',
            title: '考试分类',
            tips: '请选择考试分类'
          },
          treeProps: { checkStrictly: true },
          checkable: false
        },
        apiProps: { type: 0 },
        selectProps: {
          placeholder: '请选择考试分类'
        }
      }
    },
    {
      title: "考试分类",
      name: "categoryType",
      dataIndex: "categoryType",
      tableItem: {width:300 },
    },
    {
      title: "考试类型",
      name: "examType",
      dataIndex: "examType",
      dict: [
        { code: 0, codeName: '独立考试' },
        { code: 1, codeName: '课程考试' },
      ],
      searchItem: { type: 'select' },
      tableItem: { width: 100},
    },
    {
      title: "创建时间",
      name: "createTime",
      dataIndex: "createTime",
      tableItem: {
        width: 200,
        render: (text) => {
          return formatterDate(text)
        }
      },
    }
  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'examTemplate/listByPage',
    ...api
  }
}

const examTemp = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    rowkey: 'id',
    rowName: 'title',
    columns: columns(),
    cols: {
      xs: 12,
      md: 12,
      xl: 12
    },
    tableApi: tableApi(api)
  }
}

export default examTemp
